import React from 'react';
import { Icon as StandardIcon } from '@emorg-prd/standard-react';
import { IconTypes as StandardIconTypes } from '@emorg-prd/standard-react/components/Icon';

interface IconProps {
	size: sizeString;
	icon: IconTypes;
	className?: string;
}

type sizeString = 'small' | 'medium' | 'large';
type standardSizeString = 'em-c-icon--small' | 'em-c-icon--medium' | 'em-c-icon--large';

const sizeMapping: Record<sizeString, standardSizeString> = {
	small: 'em-c-icon--small',
	medium: 'em-c-icon--medium',
	large: 'em-c-icon--large',
};

export type IconTypes = StandardIconTypes;

export const Icon = ({ className, icon, size }: IconProps) => (
	<StandardIcon optionalClass={className} name={icon} size={sizeMapping[size]} />
);
